import Joi from 'joi';
import mediaUrlSchema from '@utils/validate/blocksSchemes/mediaUrlSchema';
import thumbnailsWithBlurSchema from '@utils/validate/blocksSchemes/thumbnailsWithBlurSchema';
import linkSchema from '@utils/validate/blocksSchemes/linkSchema';
import imageWithMetaDataSchema from '@utils/validate/blocksSchemes/imageWithMetadataSchema';
const headerSectionSchema = Joi.object({
  type: Joi.string().valid('header').required(),
  code: Joi.string().allow('', null).required(),
  slides: Joi.array().items(Joi.object({
    itemId: Joi.string().required(),
    type: Joi.string().allow('', null),
    link: linkSchema.allow('', null).required(),
    buttonText: Joi.string().allow('', null),
    buttonVerticalPosition: Joi.string().allow('', null),
    buttonHorizontalPosition: Joi.string().allow('', null),
    buttonPosition: Joi.string().allow('', null),
    buttonStyle: Joi.string().allow('', null),
    video: mediaUrlSchema,
    tablet: Joi.string().allow('', null),
    mobile: Joi.string().allow('', null),
    thumbnail: mediaUrlSchema,
    thumbnailWithBlur: thumbnailsWithBlurSchema,
    image: mediaUrlSchema,
    blur: mediaUrlSchema,
    content: Joi.object({
      textImg: Joi.alternatives().try(Joi.string(), Joi.object(imageWithMetaDataSchema)).allow(null, ''),
      topText: Joi.string().allow('', null),
      topTextColor: Joi.string().allow('', null),
      title: Joi.string().allow('', null),
      titleColor: Joi.string().allow('', null),
      description: Joi.string().allow('', null),
      descriptionColor: Joi.string().allow('', null),
      vertical: Joi.string().allow('', null),
      horizontal: Joi.string().allow('', null),
      additionalButton: Joi.object({
        additionalText: Joi.string().allow('', null),
        additionalButtonText: Joi.string().allow('', null),
        additionalButtonLink: linkSchema.allow('', null),
        additionalButtonStyle: Joi.string().allow('', null)
      }).unknown(true)
    }).unknown(true)
  }).required()).required()
}).unknown(true);
export default headerSectionSchema;